import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getString } from '../../helpers/stringHelpers.js';

// Actions
import { actions as routingActions } from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';

// Components
import PersonAddIcon from '@material-ui/icons/PersonAddOutlined';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import MonetizationIcon from '@material-ui/icons/MonetizationOnOutlined';
import BubbleChartIcon from '@material-ui/icons/BubbleChartOutlined';
import WellbeingChildLayout from './WellbeingChildLayout';
import WellbeingChildCard from './WellbeingChildCard/WellbeingChildCard';
import ReplaceContact from '../../components/Replace/ReplaceContact/ReplaceContact';

class WellbeingChild extends React.Component {
  componentDidMount() {
    const { setAppBarTitle, onLoadComplete } = this.props;
    const currentPage = this.getCurrentPage();
    setAppBarTitle(currentPage.appBarTitle);
    onLoadComplete();
  }

  getCurrentPage() {
    const { page } = this.props;

    for (let section of wellbeingSections) {
      const match = section.pages.find((child) => {
        return child.slug == String(page);
      });
      if (match) {
        return match;
      }
    }
  }

  render() {
    const { goWellbeingLanding, toggleContactModal, page } = this.props;

    const currentPage = this.getCurrentPage();

    let icon;
    switch (currentPage.icon) {
      case 'PersonAdd':
        icon = PersonAddIcon;
        break;
      case 'Monetization':
        icon = MonetizationIcon;
        break;
      case 'BubbleChart':
        icon = BubbleChartIcon;
        break;
      default:
        icon = PersonIcon;
        break;
    }

    const childCard = (
      <WellbeingChildCard
        title={currentPage.title}
        image={currentPage.image}
        imageAlt={currentPage.imageAlt}
        content={
          <ReplaceContact
            content={currentPage.content}
            action={toggleContactModal}
            isLink={true}
          />
        }
        icon={icon}
        phoneNumber={currentPage.phoneButtonNumber}
      />
    );

    return (
      <WellbeingChildLayout
        backAction={goWellbeingLanding}
        card={childCard}
        title={currentPage.appBarTitle}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  inOutage: state.app.inOutage,
  outageFrom: state.app.outageFrom,
  outageTo: state.app.outageTo,
  outageMessage: state.app.outageMessage,
  page: state.location.payload.page,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(WellbeingChild);
